import { getStoreIdForHeader } from "@Utils/reduxCommon";
import {
  buildHeaders,
  cartIdHeader,
  storeIdHeader,
} from "@wff/configs/HeadersConfig";
import { IAddToCartPayload, ICartApiResponse } from "@wff/interfaces";
import api from "../api";
import RestEndpoints from "../constants/RestEndpoints";

export const addToCartApi = (payload: IAddToCartPayload) => {
  const headers = buildHeaders(
    cartIdHeader,
    storeIdHeader(getStoreIdForHeader())
  );

  return api.put<ICartApiResponse>(
    RestEndpoints.CART.ADD_ITEM,
    {
      sku: payload.sku,
      quantity: payload.quantity,
    },
    { headers }
  );
};
